import { Image } from "primereact/image";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Button } from 'primereact/button';
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { Sidebar } from "primereact/sidebar";
import Layout from "../../../components/common/nav/payoll/nav.component";
import { MyAccountTable2 } from "../../../components/service/myaccounttable2";
import Editpopup from "../../../components/popup/editpopup";
import sideBar from "../../../assets/images/sidebarright.svg"
import user1 from "../../../assets/images/user1.svg"
import user2 from "../../../assets/images/user2.svg"
import user3 from "../../../assets/images/user3.svg"
import user4 from "../../../assets/images/user4.svg"
import user5 from "../../../assets/images/user5.svg"
import { ValidatePayrollRole } from "../../../helper/validateRole";
import { Auth, DataStore, Predicates, SortDirection } from 'aws-amplify';
import Login from "../../../setup/auth/login.component";
import { InitiateClassifiedWeeklyAbsenceReport, InitiateClassifiedWeeklyAbsenceReportEmployee, InitiateClassifiedWeeklyAbsenceReportEmployeeDetails, Employee, Schools, InitiateClassifiedWeeklyAbsenceReportStatus, ReportsLog, SixthPeriodAssignmentInitiateReport } from "../../../models";
import moment from "moment";
import { GetValueFromArray } from "../../../helper/commonfunctions";
import AWS from "aws-sdk";
import awsmobile from "../../../aws-exports";
import { Dialog } from "primereact/dialog";
import pdfImage from '../../../assets/images/pdfImage.png'
import sideBarRight from "../../../assets/images/sidebarright.svg"
import pdfImageForEdit from '../../../assets/images/pdfImageForEdit.png';
import sidebar from "../../../assets/images/sidebarright.svg"
import pdfImageReport from '../../../assets/images/pdfImageReport.png';
import { reactLocalStorage } from "reactjs-localstorage";

const ServiceAgreementPayrollReportList = () => {

    const [selectedProducts, setSelectedProducts] = useState(null);
    const [fullViewEdit, setFullViewEdit] = useState(false);
    const [fullViewForView, setFullViewForView] = useState(false);
    const [visibleEdit, setVisibleEdit] = useState(false);
    const [confirmVisible, setConfirmVisible] = useState(false);
    const [rejectVisible, setRejectVisible] = useState(false);
    const [payrollReportList, setPayrollReportList] = useState([]);
    //SET AWS Configuration
    AWS.config.update({
        accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
        secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
        region: process.env.REACT_APP_AWS_Region,
    });

    //*state
    const [activate, setActivate] = useState("");
    const toggleActive = () => {
        setActivate(activate === "actives" ? "" : "actives");
    };
    const [checked, setChecked] = useState(false);
    const [visibleRight, setVisibleRight] = useState(false);
    const [visible, setVisible] = useState(false);
    const [position, setPosition] = useState('center');
    const [weeklyAbsenceReportSubmitted, setWeeklyAbsenceReportSubmitted] = useState();
    const [weeklyAbsenceReportApproved, setWeeklyAbsenceReportApproved] = useState();
    const [weeklyAbsenceReportRejected, setWeeklyAbsenceReportRejected] = useState();


    //*List
    const [myaccountt, setProducts] = useState([]);
    const [weeklyAbsenceReports, setWeeklyAbsenceReports] = useState([]);


    const [employeeList, setEmployeeList] = useState([]);
    const [reportEmployeeList, setReportEmployeeList] = useState([]);
    const [users, SetUsersList] = useState([]);
    const [reportLogList, SetReportLogList] = useState([]);

    //_____popup

    //*state
    const [reportId, setReportId] = useState('');
    const [schoolName, setSchoolName] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [status, setStatus] = useState('');
    const [submittedBy, setSubmittedBy] = useState('');
    const [approvedBy, setApprovedBy] = useState('');


    //Validate User Logged In
    const [isAuthenticated, userHasAuthenticated] = useState(true);


    async function onLoad() {
        try {
            await Auth.currentSession();
            if (!ValidatePayrollRole()) { userHasAuthenticated(false); }
        } catch (e) {
            userHasAuthenticated(false);
        }
    }

    const show = (position) => {
        setPosition(position);
        setVisible(true);
    };

    const TaskStatusSL = (product) => {

        console.log("product", product);
        switch (product.status) {
            case 'Rejected':
                return 'danger';

            // case 'Closed':
            //   return 'danger';

            case 'Closed':
                return 'success';

            case 'Submitted':
                return 'info';

            case 'Open':
                return 'info';

            default:
                return null;
        }
    };

    const TaskStatusSLA = (product) => {
        return <Tag value={product.status} severity={TaskStatusSL(product)}></Tag>;
    };
    const alljobactionContent = (row) => {
        return (
            <div className="flex justify-center w-full gap-2">
                {
                    row.status === 'Open' ?
                        <Link to='' className="py-2 px-2.5" onClick={() => { setVisibleEdit(true); onClickPopup(row); }}><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link> :
                        row.status === 'Closed' ?
                            <Link to='' className="py-2 px-2.5" onClick={() => { show('right'); onClickPopup(row); }}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                            row.status === 'Rejected' ?
                                <Link to='' className="py-2 px-2.5" onClick={() => { show('right'); onClickPopup(row); }}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                                null
                }
            </div>
        );
    };

    //* onclick popup
    const onClickPopup = async (requestData) => {
        setReportId(requestData.id);
        loadReportLogs(requestData.id);
        let fromDate = moment(requestData.from_date, 'YYYY-DD-MM').format('Do MMMM YYYY'); setFromDate(fromDate);
        let toDate = moment(requestData.to_date, 'YYYY-DD-MM').format('Do MMMM YYYY'); setToDate(toDate);
        setSchoolName(requestData.schoolName); setStatus(requestData.status)
        if (requestData.approver_by !== null) { let submittedBy = getUserResponse(requestData.approver_by); setSubmittedBy(submittedBy); }
        if (requestData.payroll_by !== null) { let approvedBy = getUserResponse(requestData.payroll_by); setApprovedBy(approvedBy); }
        if (requestData.id) {
            let newResponse = [];
            var employeeResponses = await DataStore.query(InitiateClassifiedWeeklyAbsenceReportEmployee, (c) => c.initiate_classified_weekly_absence_report_id.eq(requestData.id));
            if (employeeResponses.length > 0) {
                employeeResponses.map(async (item, index) => {
                    let employeeName; let substitutedEmployeeName;

                    if (item.employee_id) {
                        let employeeData = await getEmployeeResponse(item.employee_id)
                        if (employeeData) { employeeName = employeeData.employee_name } else { employeeName = "-" }
                    } else {
                        employeeName = "-";
                    }

                    var employeeDetailsResponses = await DataStore.query(InitiateClassifiedWeeklyAbsenceReportEmployeeDetails, (c) => c.initiate_classified_weekly_absence_report_employee_id.eq(item.id));

                    if (employeeDetailsResponses[0].substitute_emp_id) {
                        let substituteEmployeeData = await getEmployeeResponse(employeeDetailsResponses[0].substitute_emp_id)
                        if (substituteEmployeeData) { substitutedEmployeeName = substituteEmployeeData.employee_name } else { substitutedEmployeeName = "-" }
                    } else {
                        substitutedEmployeeName = "-";
                    }

                    let absent_date = moment(employeeDetailsResponses[0].absent_date).format("Do MMMM'YY");

                    newResponse.push({ "employeeName": employeeName, "absent_date": absent_date, "absent_code_id": employeeDetailsResponses[0].absent_code_id, "substitutedEmployeeName": substitutedEmployeeName, "partial_hour": employeeDetailsResponses[0].partial_hour })

                    if (index === employeeResponses.length - 1) {
                        setReportEmployeeList(newResponse)
                    }
                })
            } else {
                setReportEmployeeList([])
            }
        }
    }

    //*get getEmployeeResponse
    const getEmployeeResponse = (id) => {
        let _employeeList = [...employeeList];
        var returnRecord = _employeeList.find(o => o.id === String(id));
        if (returnRecord !== null && returnRecord !== undefined) { return returnRecord; } else { return null; }
    }

    //*get getEmployeeResponse
    const getUserResponse = (id) => {
        let _userList = [...users];
        let getEmployeeResponse = _userList.filter((item) => item.Username === id)
        let firstName = GetValueFromArray(getEmployeeResponse[0].Attributes, "custom:firstName");
        let lastName = GetValueFromArray(getEmployeeResponse[0].Attributes, "custom:lastName");
        let fullName = firstName + " " + lastName;
        return fullName;
    }

    //*loadAbsenceReport
    const loadAbsenceReport = async () => {

        //Set Weekly Absence Report-Classified List
        var weeklyAbsenceReport = await DataStore.query(InitiateClassifiedWeeklyAbsenceReport)
        let newResponse = [];
        for (let i = 0; i < weeklyAbsenceReport.length; i++) {

            if (weeklyAbsenceReport[i].approver_status === InitiateClassifiedWeeklyAbsenceReportStatus.APPROVAL_ACCEPTED) {

                let schoolName = "";
                let workDuration = "";
                let submittedOn = "";
                let status = "";
                let submittedBy = "";
                let submittedUser;

                //*School Name
                if (weeklyAbsenceReport[i].school_id !== null && weeklyAbsenceReport[i].school_id !== undefined) {
                    var schoolResponses = await DataStore.query(Schools, (c) => c.id.eq(weeklyAbsenceReport[i].school_id));
                    if (schoolResponses.length > 0) { schoolName = schoolResponses[0].name; } else { schoolName = ""; }
                } else { schoolName = ""; }

                //*Get user
                let userId = weeklyAbsenceReport[i].approver_by
                const cognito = await new AWS.CognitoIdentityServiceProvider();
                if (userId) {
                    try {
                        submittedUser = await cognito.adminGetUser({
                            UserPoolId: awsmobile.aws_user_pools_id,
                            Username: userId,
                        }).promise();

                        let exist = submittedUser ? submittedUser : '';
                        let firstName = GetValueFromArray(exist.UserAttributes, "custom:firstName");
                        let lastName = GetValueFromArray(exist.UserAttributes, "custom:lastName");
                        submittedBy = firstName + " " + lastName
                    } catch (e) {
                        //console.log(e)
                    }
                } else {
                    submittedBy = "-"
                }

                //*Work Duration
                if (weeklyAbsenceReport[i].from_date !== null && weeklyAbsenceReport[i].to_date !== null) {
                    let fromDate = moment(weeklyAbsenceReport[i].from_date, 'YYYY-DD-MM').format('Do');
                    let toDate = moment(weeklyAbsenceReport[i].to_date, 'YYYY-DD-MM').format("Do MMMM'YY");
                    workDuration = fromDate + " - " + toDate
                } else { workDuration = "-" }


                //*submitted On
                if (weeklyAbsenceReport[i].approver_date_time !== null && weeklyAbsenceReport[i].approver_date_time !== undefined) {
                    submittedOn = weeklyAbsenceReport[i].approver_date_time !== null ? moment(weeklyAbsenceReport[i].approver_date_time).format("Do MMMM'YY") : "-";
                } else { submittedOn = "-" }

                if (weeklyAbsenceReport[i].payroll_status !== InitiateClassifiedWeeklyAbsenceReportStatus.PAYROLL_ACCEPTED && weeklyAbsenceReport[i].payroll_status !== InitiateClassifiedWeeklyAbsenceReportStatus.PAYROLL_REJECTED) {
                    status = "open"
                } else if (weeklyAbsenceReport[i].payroll_status === InitiateClassifiedWeeklyAbsenceReportStatus.PAYROLL_ACCEPTED) {
                    status = "Closed"
                } else if (weeklyAbsenceReport[i].payroll_status === InitiateClassifiedWeeklyAbsenceReportStatus.PAYROLL_REJECTED) {
                    status = "Rejected"
                }

                newResponse.push({
                    "id": weeklyAbsenceReport[i].id, "user_id": weeklyAbsenceReport[i].user_id, "status": status, "school_id": weeklyAbsenceReport[i].school_id, "from_date": weeklyAbsenceReport[i].from_date,
                    "to_date": weeklyAbsenceReport[i].to_date, "status_date_time": weeklyAbsenceReport[i].status_date_time, "approver_status": weeklyAbsenceReport[i].approver_status, "approver_by": weeklyAbsenceReport[i].approver_by, "approver_date_time": weeklyAbsenceReport[i].approver_date_time, "payroll_status": weeklyAbsenceReport[i].payroll_status, "payroll_by": weeklyAbsenceReport[i].payroll_by, "payroll_date_time": weeklyAbsenceReport[i].payroll_date_time,
                    "approver_remark": weeklyAbsenceReport[i].approver_remark, "payroll_remark": weeklyAbsenceReport[i].payroll_remark !== null ? weeklyAbsenceReport[i].payroll_remark : "-", "schoolName": schoolName, "workDuration": workDuration, "submittedOn": submittedOn, "submittedBy": submittedBy, "createdAt": weeklyAbsenceReport[i].createdAt, "updatedAt": weeklyAbsenceReport[i].updatedAt,
                })
            }

            if (i === weeklyAbsenceReport.length - 1) {
                setWeeklyAbsenceReports(newResponse)

                //*Pending for Approval
                const submittedCount = newResponse.filter(obj => obj.status === "open");
                setWeeklyAbsenceReportSubmitted(submittedCount.length)

                //*Approved
                const approvedCount = newResponse.filter(obj => obj.status === "Closed")
                setWeeklyAbsenceReportApproved(approvedCount.length)

                //* RejectedCount
                const rejectedCount = newResponse.filter(obj => obj.status === "Rejected")
                setWeeklyAbsenceReportRejected(rejectedCount.length)
            }
        }
    }

    const loadReportLogs = async (reportId) => {

        //*Report Logs Response
        var loadReportLogsResponse = await DataStore.query(ReportsLog, (c) => c.report_id.eq(reportId));
        if (loadReportLogsResponse.length > 0) {
            let newResponse = [];
            for (let i = 0; i < loadReportLogsResponse.length > 0; i++) {

                let submittedUser;
                let name;
                let ProfilePic;
                let dateTime = moment(loadReportLogsResponse[i].date_and_time).format('HH:mm');
                //*Get user
                let userId = loadReportLogsResponse[i].user_id
                const cognito = await new AWS.CognitoIdentityServiceProvider();
                if (userId) {
                    try {
                        submittedUser = await cognito.adminGetUser({
                            UserPoolId: awsmobile.aws_user_pools_id,
                            Username: userId,
                        }).promise();

                        let exist = submittedUser ? submittedUser : '';
                        let firstName = GetValueFromArray(exist.UserAttributes, "custom:firstName");
                        let lastName = GetValueFromArray(exist.UserAttributes, "custom:lastName");
                        name = firstName + " " + lastName
                        let profilePath = GetValueFromArray(exist.UserAttributes, "picture");
                        // console.log("profilePath-----" + profilePath)
                        if (profilePath !== undefined) {
                            await Storage.get(profilePath)
                                .then(result => {
                                    ProfilePic = result;
                                });
                        } else { ProfilePic = user1; }
                    } catch (e) {
                        //console.log(e)
                    }
                } else {
                }
                newResponse.push({
                    "id": loadReportLogsResponse[i].id, "report_id": loadReportLogsResponse[i].report_id, "comment": loadReportLogsResponse[i].comment, "date_and_time": loadReportLogsResponse[i].date_and_time,
                    "user_id": loadReportLogsResponse[i].user_id, "createdAt": loadReportLogsResponse[i].createdAt, "dateTime": dateTime, "name": name, "ProfilePic": ProfilePic, "updatedAt": loadReportLogsResponse[i].updatedAt,
                })

                if (i === loadReportLogsResponse.length - 1) {
                    SetReportLogList(newResponse);
                }
            }
        } else {
            SetReportLogList([]);
        }

    }


    const BindList = async () => {
        const loggedUserId = reactLocalStorage.get("loggedUserId");
        //fetch all SixthPeriodAssignmentInitiateReport table data
        try {
            const sixPeriodInitiatorReportResponse = await DataStore.query(SixthPeriodAssignmentInitiateReport,
                (c) => c.approved_by.eq(loggedUserId),
                Predicates.ALL, {
                sort: s => s.assignment_title(SortDirection.ASCENDING)
            });
            if (sixPeriodInitiatorReportResponse) {

                console.log("data is bbbbbbbbbb app:-", sixPeriodInitiatorReportResponse);
                //change data format according to UI.
                // let pendingCount = 0;
                // let approvedCount = 0;
                // let rejectCount = 0;
                let finalData = [];
                sixPeriodInitiatorReportResponse.map((currentItem, i) => {

                    //change format of period attribute
                    const startDate = new Date(currentItem.from_date);
                    const endDate = new Date(currentItem.to_date);

                    const dateFormatter = new Intl.DateTimeFormat('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
                    const formattedStartDate = dateFormatter.format(startDate);
                    const formattedEndDate = dateFormatter.format(endDate);
                    const period = `${formattedStartDate} to ${formattedEndDate}`;
                    // const status = (currentItem.approved_by) ? 'Approved' : 'Pending for Approval';
                    const status = 'Open';

                    let obj = {
                        id: currentItem.id,
                        srNo: i + 1,
                        assignmentTitle: currentItem.assignment_title,
                        period: period,
                        submittedOn: currentItem.submited_at,

                        status: status,
                        // status: currentItem.status.charAt(0).toUpperCase() + currentItem.status.slice(1).toLowerCase(),
                        // remark:currentItem.remark

                        employee_id: currentItem.employee_id,
                        assighment_at: currentItem.assighment_at,
                        from_date: currentItem.from_date,
                        to_date: currentItem.to_date,
                        subject_area: currentItem.subject_area,
                        total_staffing_allocation: currentItem.total_staffing_allocation,
                        account_charged: currentItem.account_charged,
                        current_fte_utilized: currentItem.current_fte_utilized
                    }

                    //specific report category get approved,submitted and rejected count

                    // if (status === 'Pending for Approval') {
                    //   pendingCount++;
                    // } else if (status === 'Approved') {
                    //   approvedCount++;
                    // } else {
                    //   rejectCount++;
                    // }
                    // setPendingCount(pendingCount);
                    // setApprovedCount(approvedCount);
                    // setRejectCount(rejectCount);

                    finalData.push(obj);
                })

                setPayrollReportList(finalData)
            }
        } catch (error) {
            console.log('Error for bindList', error);
        }

    }

    useEffect(() => {
        BindList();
        // onLoad();
    }, []);





    return isAuthenticated ? (
        <>
            <Layout pageTitle="Report">
                <div className="report-wrapper pt-24 md:pt-28 xl:pt-[2.083vw]">
                    <div className="flex justify-end visible lg:hidden">
                        <Button icon="pi pi-bars" onClick={toggleActive} style={{ color: '#308B90', background: '#ffffff00', border: '1', borderColor: '#308B90', width: '38px', padding: '6px 0', borderRadius: '4px' }}></Button>

                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-3 xl:gap-[1.250vw] pb-5">
                        <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-3">
                            <div>
                                <div id={activate} className="bg-[#FFFFFF] rounded-lg box-shadow-1 radius4 p-4 xl:p-[0.833vw] top-5 lg:sticky fixed -left-96 lg:left-0 lg:overflow-hidden lg:h-auto z-10" data-aos="fade-up" data-aos-duration="800">
                                    <div className="flex justify-between text-[#101828] font-medium text-base tracking-[0.02em] xl:text-[0.932vw]">
                                        <p>Forms</p>
                                        <div className="xl:w-[10.058vw] md:w-[200px] custinput">
                                            <span className="w-full p-input-icon-left">
                                                <i className="gusd-search text-[#667085] mt-0" />
                                                <InputText placeholder="Search" className="w-full" />
                                            </span>
                                        </div>
                                    </div>

                                    <div className="mt-4 h-[600px] xl:h-[38vw]  overflow-auto">

                                        <div className="bg-[#0F1E4C]  radius4 p-[16px] xl:p-[0.833vw]">
                                            <h6 className="font-medium text-[16px] text-[#fff] xl:text-[0.833vw] mb-2">6th Period Teaching Assignment</h6>
                                            <div className="flex justify-between gap-2 xl:gap-[0.833vw] xl:mt-[0.833vw]">
                                                <div className="flex items-center gap-1">
                                                    <div className="bg-[#EAEFFF] text-[16px] xl:text-[0.833vw] border border-[#99B2FF] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                        {/* {weeklyAbsenceReportSubmitted === 0 ? 0 : weeklyAbsenceReportSubmitted} */}
                                                        0
                                                    </div>
                                                    <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">Resubmitted</div>
                                                </div>
                                                <div className="flex items-center gap-1">
                                                    <div className="bg-[#D1FADF] text-[16px] xl:text-[0.833vw] border border-[#A6F4C5] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                        0
                                                        {/* {weeklyAbsenceReportApproved === 0 ? 0 : weeklyAbsenceReportApproved} */}
                                                    </div>
                                                    <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">Approved </div>
                                                </div>
                                                <div className="flex items-center gap-1">
                                                    <div className="bg-[#FEF3F2] text-[16px] xl:text-[0.833vw] border border-[#FEE4E2] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                        0
                                                        {/* {weeklyAbsenceReportRejected === 0 ? 0 : weeklyAbsenceReportRejected} */}
                                                    </div>
                                                    <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">Rejected</div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <div className="bg-[#fff]  radius4 p-[16px] xl:p-[0.833vw] border-b border-[#E4E7EC]">
                                        <h6 className="font-normal text-[16px] text-[#344054] xl:text-[0.833vw] mb-2">6th Period Teaching Assignment</h6>
                                        <div className="flex justify-between gap-2 xl:gap-[0.833vw] xl:mt-[0.833vw]">
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#EAEFFF] xl:text-[0.833vw] border border-[#99B2FF] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    32
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw]  text-[#344054] font-normal">Submitted</div>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#D1FADF] text-[16px] xl:text-[0.833vw] border border-[#A6F4C5] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    9
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw] text-[#344054] font-normal">Approved </div>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#FEF3F2] text-[16px] xl:text-[0.833vw] border border-[#FEE4E2] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    2
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw] text-[#344054] font-normal">Rejected</div>
                                            </div>
                                        </div>
                                    </div> */}
                                        {/* <div className="bg-[#fff]  radius4 p-[16px] xl:p-[0.833vw] border-b border-[#E4E7EC]">
                                        <h6 className="font-medium text-[16px] text-[#344054] xl:text-[0.833vw] mb-2">Weekly Absence Report- Certificated_Admin</h6>
                                        <div className="flex justify-between gap-2 xl:gap-[0.833vw] xl:mt-[0.833vw]">
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#EAEFFF] xl:text-[0.833vw] border border-[#99B2FF] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    32
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw]  text-[#344054] font-normal">Submitted</div>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#D1FADF] text-[16px] xl:text-[0.833vw] border border-[#A6F4C5] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    9
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw] text-[#344054] font-normal">Approved </div>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#FEF3F2] text-[16px] xl:text-[0.833vw] border border-[#FEE4E2] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    2
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw] text-[#344054] font-normal">Rejected</div>
                                            </div>
                                        </div>
                                    </div> */}
                                        {/* <div className="bg-[#fff]  radius4 p-[16px] xl:p-[0.833vw] border-b border-[#E4E7EC]">
                                        <h6 className="font-medium text-[16px] text-[#344054] xl:text-[0.833vw] mb-2">
                                            Classified Sub Time Report</h6>
                                        <div className="flex justify-between gap-2 xl:gap-[0.833vw] xl:mt-[0.833vw]">
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#EAEFFF] xl:text-[0.833vw] border border-[#99B2FF] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    32
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw]  text-[#344054] font-normal">Submitted</div>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#D1FADF] text-[16px] xl:text-[0.833vw] border border-[#A6F4C5] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    9
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw] text-[#344054] font-normal">Approved </div>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#FEF3F2] text-[16px] xl:text-[0.833vw] border border-[#FEE4E2] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    2
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw] text-[#344054] font-normal">Rejected</div>
                                            </div>
                                        </div>
                                    </div> */}
                                        {/* <div className="bg-[#fff]  radius4 p-[16px] xl:p-[0.833vw] border-b border-[#E4E7EC]">
                                        <h6 className="font-medium text-[16px] text-[#344054] xl:text-[0.833vw] mb-2">
                                            Time Report</h6>
                                        <div className="flex justify-between gap-2 xl:gap-[0.833vw] xl:mt-[0.833vw]">
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#EAEFFF] xl:text-[0.833vw] border border-[#99B2FF] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    32
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw]  text-[#344054] font-normal">Submitted</div>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#D1FADF] text-[16px] xl:text-[0.833vw] border border-[#A6F4C5] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px]text-center">
                                                    9
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw] text-[#344054] font-normal">Approved </div>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#FEF3F2] text-[16px] xl:text-[0.833vw] border border-[#FEE4E2] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    2
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw] text-[#344054] font-normal">Rejected</div>
                                            </div>
                                        </div>
                                    </div> */}
                                        {/* <div className="bg-[#fff]  radius4 p-[16px] xl:p-[0.833vw] border-b border-[#E4E7EC]">
                                        <h6 className="font-medium text-[16px] text-[#344054] xl:text-[0.833vw] mb-2">
                                            Substitute Request-Certificated</h6>
                                        <div className="flex justify-between gap-2 xl:gap-[0.833vw] xl:mt-[0.833vw]">
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#EAEFFF] xl:text-[0.833vw] border border-[#99B2FF] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    32
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw]  text-[#344054] font-normal">Submitted</div>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#D1FADF] text-[16px] xl:text-[0.833vw] border border-[#A6F4C5] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    9
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw] text-[#344054] font-normal">Approved </div>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#FEF3F2] text-[16px] xl:text-[0.833vw] border border-[#FEE4E2] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    2
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw] text-[#344054] font-normal">Rejected</div>
                                            </div>
                                        </div>
                                    </div> */}
                                        {/* <div className="bg-[#fff]  radius4 p-[16px] xl:p-[0.833vw] border-b border-[#E4E7EC]">
                                        <h6 className="font-normal text-[16px] text-[#344054] xl:text-[0.833vw] mb-2">6th Period Teaching Assignment</h6>
                                        <div className="flex justify-between gap-2 xl:gap-[0.833vw] xl:mt-[0.833vw]">
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#EAEFFF] xl:text-[0.833vw] border border-[#99B2FF] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    32
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw]  text-[#344054] font-normal">Submitted</div>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#D1FADF] text-[16px] xl:text-[0.833vw] border border-[#A6F4C5] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    9
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw] text-[#344054] font-normal">Approved </div>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#FEF3F2] text-[16px] xl:text-[0.833vw] border border-[#FEE4E2] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    2
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw] text-[#344054] font-normal">Rejected</div>
                                            </div>
                                        </div>
                                    </div> */}
                                        {/* <div className="bg-[#fff]  radius4 p-[16px] xl:p-[0.833vw] border-b border-[#E4E7EC]">
                                        <h6 className="font-medium text-[16px] text-[#344054] xl:text-[0.833vw] mb-2">Weekly Absence Report- Certificated_Admin</h6>
                                        <div className="flex justify-between gap-2 xl:gap-[0.833vw] xl:mt-[0.833vw]">
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#EAEFFF] xl:text-[0.833vw] border border-[#99B2FF] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    32
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw]  text-[#344054] font-normal">Submitted</div>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#D1FADF] text-[16px] xl:text-[0.833vw] border border-[#A6F4C5] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    9
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw] text-[#344054] font-normal">Approved </div>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#FEF3F2] text-[16px] xl:text-[0.833vw] border border-[#FEE4E2] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    2
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw] text-[#344054] font-normal">Rejected</div>
                                            </div>
                                        </div>
                                    </div> */}
                                        {/* <div className="bg-[#fff]  radius4 p-[16px] xl:p-[0.833vw] border-b border-[#E4E7EC]">
                                        <h6 className="font-normal text-[16px] text-[#344054] xl:text-[0.833vw] mb-2">6th Period Teaching Assignment</h6>
                                        <div className="flex justify-between gap-2 xl:gap-[0.833vw] xl:mt-[0.833vw]">
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#EAEFFF] xl:text-[0.833vw] border border-[#99B2FF] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    32
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw]  text-[#344054] font-normal">Submitted</div>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#D1FADF] text-[16px] xl:text-[0.833vw] border border-[#A6F4C5] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    9
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw] text-[#344054] font-normal">Approved </div>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#FEF3F2] text-[16px] xl:text-[0.833vw] border border-[#FEE4E2] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    2
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw] text-[#344054] font-normal">Rejected</div>
                                            </div>
                                        </div>
                                    </div> */}
                                        {/* <div className="bg-[#fff]  radius4 p-[16px] xl:p-[0.833vw] border-b border-[#E4E7EC]">
                                        <h6 className="font-medium text-[16px] text-[#344054] xl:text-[0.833vw] mb-2">Weekly Absence Report- Certificated_Admin</h6>
                                        <div className="flex justify-between gap-2 xl:gap-[0.833vw] xl:mt-[0.833vw]">
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#EAEFFF] xl:text-[0.833vw] border border-[#99B2FF] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    32
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw]  text-[#344054] font-normal">Submitted</div>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#D1FADF] text-[16px] xl:text-[0.833vw] border border-[#A6F4C5] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    9
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw] text-[#344054] font-normal">Approved </div>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#FEF3F2] text-[16px] xl:text-[0.833vw] border border-[#FEE4E2] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                    2
                                                </div>
                                                <div className="text-[12px] xl:text-[0.625vw] text-[#344054] font-normal">Rejected</div>
                                            </div>
                                        </div>
                                    </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="relative z-10 col-span-12 lg:col-span-9" data-aos="fade-down" data-aos-duration="800">
                            <div className="bg-[#fff] box-shadow-2 radius8 border border-[#E4E7EC]" >
                                <div className="flex items-center justify-between p-[20px] xl:px-[1.250vw] xl:py-[0.990vw] border-b border-[#E4E7EC] ">
                                    <p className="text-[18px] xl:text-[0.938vw]  text-[#101828] font-medium">6th Period Teaching Assignment</p>
                                    <div className="flex gap-2 xl:gap-[0.990vw] items-center">

                                        {
                                            (selectedProducts != null && selectedProducts.length > 0) ?
                                                <Link to='/payroll/initiatepayrollreport' className="w-full text-center tableBtn blue radius8">
                                                    <i className="gusd-check mx-1.5 "></i>Bulk Approval</Link> : null
                                        }

                                        <div className="relative dropcheck">
                                            <Menu as="div">
                                                <Menu.Button><i className="gusd-filter-1"></i></Menu.Button>
                                                <Transition
                                                    as={Fragment}

                                                    enter="transition ease-out duration-100"
                                                    enterFrom="transform opacity-0 scale-95"
                                                    enterTo="transform opacity-100 scale-100"
                                                    leave="transition ease-in duration-75"
                                                    leaveFrom="transform opacity-100 scale-100"
                                                    leaveTo="transform opacity-0 scale-95"
                                                >
                                                    <Menu.Items className="absolute right-0 z-50 w-[100px] xl:w-[9.542vw]  origin-top-right bg-white rounded-[5px] xl:rounded-[5px] shadow-[0px_2px_2px_rgba(20, 46, 82, 0.2)]">
                                                        <div className="px-4 pt-5 pb-3 xl:px-[0.833vw] xl:py-[0.833vw] top-[-10px]">
                                                            <div className="mb-4 xl:mb-[0.417vw]">
                                                                <div className="flex items-center mb-2">
                                                                    <Checkbox onChange={e => setChecked(e.checked)} checked={checked}></Checkbox>
                                                                    <label htmlFor="ingredient1" className="ml-2 text-[#344054] text-[15px] font-medium xl:text-[0.900vw]">Year</label>
                                                                </div>
                                                                <div className="flex items-center mb-3">
                                                                    <Checkbox onChange={e => setChecked(e.checked)} checked={checked}></Checkbox>
                                                                    <label htmlFor="ingredient1" className="ml-2 text-[#344054] text-[15px] font-medium xl:text-[0.900vw]">Month</label>
                                                                </div>
                                                                <Link to="" className="flex justify-center bg-[#3366FF] text-[14px] text-[#fff] px-5 py-1.5  rounded-md w-full">Select</Link>
                                                            </div>
                                                        </div>
                                                    </Menu.Items>
                                                </Transition>
                                            </Menu>
                                        </div>
                                        <Link to=""> <i className="gusd-expand"></i></Link>
                                    </div>
                                </div>
                                <div className="">
                                    <DataTable className="custpaginator custIcons custmBtnTable custTable" scrollable
                                        value={payrollReportList
                                            // [
                                            //   {
                                            //     user_id: '1',
                                            //     assignmentTitle: 'Assignment 1',
                                            //     period: '1st Jan 2023 to 31st Mar 2023',
                                            //     submittedOn: '13th Mar 23',
                                            //     status: 'Closed'
                                            //   },
                                            //   {
                                            //     user_id: '2',
                                            //     assignmentTitle: 'Assignment 2',
                                            //     period: '1st Jan 2023 to 31st Mar 2023',
                                            //     submittedOn: '13th Mar 23',
                                            //     status: 'Open'
                                            //   },
                                            //   {
                                            //     user_id: '3',
                                            //     assignmentTitle: 'Assignment 3',
                                            //     period: '1st Jan 2023 to 31st Mar 2023',
                                            //     submittedOn: '13th Mar 23',
                                            //     status: 'Rejected'
                                            //   }
                                            // ]
                                        } paginator responsiveLayout="scroll" paginatorTemplate="PrevPageLink PageLinks NextPageLink" rows={11}
                                        selectionMode='checkbox' selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)} dataKey="user_id"
                                    >
                                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                                        <Column field="user_id" header="SL#" sortable style={{ minWidth: '3rem' }} body={(data, options) => options.rowIndex + 1}></Column>
                                        <Column field="assignmentTitle" header="Assignment Title" sortable style={{ minWidth: '5rem' }}></Column>
                                        <Column field="period" header="Period" sortable></Column>
                                        <Column field="submittedOn" header="Submitted On" sortable style={{ minWidth: '5rem' }}></Column>
                                        {/* <Column field="submittedBy" header="Submitted by" sortable></Column> */}
                                        <Column header="status" body={TaskStatusSLA} sortable style={{ minWidth: '8rem' }}></Column>
                                        <Column field="payroll_remark" header="Remarks" sortable style={{ minWidth: '5rem' }}></Column>
                                        <Column field="action" header="Action" frozen alignFrozen="right" align='center' body={alljobactionContent} style={{ minWidth: '6rem' }}></Column>
                                    </DataTable>
                                </div>


                                {/* view popup */}
                                <Dialog className="relative reports-popup" visible={visible} position={position}
                                    style={{ width: '80vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisible(false)} draggable={false} resizable={false}>
                                    <div className="grid grid-cols-1 lg:grid-cols-12">
                                        <div className="col-span-1 lg:col-span-8 bg-[#F5F6F7] h-auto">
                                            <div className="p-5">
                                                <div onClick={() => setVisible(false)} className="py-3">
                                                    <Image src={sideBarRight} alt="user" width="24" height="24" /></div>

                                                {
                                                    (!fullViewForView) ?
                                                        <div>
                                                            <div className='text-center'>
                                                                <div className="text-[#000000] text-md lg:text-[0.833vw] font-bold">GLENDALE UNIFIED SCHOOL DISTRICT</div>
                                                                <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Request For Approval - Sixth Period Teaching Assignment</div>
                                                            </div>
                                                            <div className='pt-3'>
                                                                <p>Approval Status</p>
                                                                <div className="py-3 emp-simple-tbl">
                                                                    <DataTable
                                                                        value={[
                                                                            {
                                                                                id: '1000',
                                                                                title: 'Principal',
                                                                                name: 'Alrick Barwa',
                                                                                status: 'Approved'
                                                                            },
                                                                            {
                                                                                id: '1001',
                                                                                title: 'Teacher',
                                                                                name: 'John Mishra',
                                                                                status: 'Approved'
                                                                            },
                                                                            {
                                                                                id: '1002',
                                                                                title: 'EAFE Program Administrator',
                                                                                name: 'Alrick Barwa',
                                                                                status: 'Approved'
                                                                            }

                                                                        ]}>
                                                                        <Column field="title" header="Title"></Column>
                                                                        <Column field="name" header="Name"></Column>
                                                                        <Column field="status" header="Status"></Column>
                                                                    </DataTable>
                                                                </div>
                                                            </div>
                                                        </div> : null
                                                }


                                                <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">


                                                    <div className='flex justify-between'>
                                                        <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-file-icon"></i>Sixth Period Teaching Assignment.pdf</div>

                                                        {
                                                            (!fullViewForView) ?
                                                                <button onClick={() => setFullViewForView(true)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>View Full Screen</button>
                                                                :
                                                                <button onClick={() => setFullViewForView(false)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>Exit Full Screen</button>

                                                        }
                                                    </div>

                                                    <div className="grid grid-cols-1">
                                                        <img src={pdfImage} alt='myImg' />
                                                    </div>
                                                </div>



                                                {/* <div className="py-3 emp-simple-tbl">
                          <DataTable value={reportEmployeeList}>
                            <Column field="employeeName" header="Name of Employee"></Column>
                            <Column field="absent_date" header="Dates Absent"></Column>
                            <Column field="absent_code_id" header="Absent Codes"></Column>
                            <Column field="substitutedEmployeeName" header="Substitute"></Column>
                            <Column field="partial_hour" header="Total Hours"></Column>
                          </DataTable>
                        </div> */}

                                                {/* <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">
                          <div className="text-[#344054] font-medium text-[14px] pb-3">Absence Codes - Legends</div>
                          <div className="grid grid-cols-1 md:grid-cols-2">
                            <div className="text-[#344054] text-[12px]">
                              <div className="grid grid-cols-5 pb-0.5">
                                <div className="col-span-1 font-semibold text-right">L -</div>
                                <div className="col-span-4 pl-1">Last Day Worked</div>
                              </div>
                              <div className="grid grid-cols-5 pb-0.5">
                                <div className="col-span-1 font-semibold text-right">NA -</div>
                                <div className="col-span-4 pl-1">Personal (Not Approved)</div>
                              </div>
                              <div className="grid grid-cols-5 pb-0.5">
                                <div className="col-span-1 font-semibold text-right">OU -</div>
                                <div className="col-span-4 pl-1">Other Unpaid</div>
                              </div>
                              <div className="grid grid-cols-5 pb-0.5">
                                <div className="col-span-1 font-semibold text-right">PA -</div>
                                <div className="col-span-4 pl-1">Personal (Approved)</div>
                              </div>
                              <div className="grid grid-cols-5 pb-0.5">
                                <div className="col-span-1 font-semibold text-right">WC -</div>
                                <div className="col-span-4 pl-1">Personal (Approved)</div>
                              </div>
                              <div className="grid grid-cols-5 pb-0.5">
                                <div className="col-span-1 font-semibold text-right">D -</div>
                                <div className="col-span-4 pl-1">District Approved</div>
                              </div>
                              <div className="grid grid-cols-5 pb-0.5">
                                <div className="col-span-1 font-semibold text-right">I -</div>
                                <div className="col-span-4 pl-1">Illness</div>
                              </div>
                            </div>
                            <div className="text-[#344054] text-[12px]">
                              <div className="grid grid-cols-5 pb-0.5">
                                <div className="col-span-1 font-semibold text-right">L -</div>
                                <div className="col-span-4 pl-1">Last Day Worked</div>
                              </div>
                              <div className="grid grid-cols-5 pb-0.5">
                                <div className="col-span-1 font-semibold text-right">NA -</div>
                                <div className="col-span-4 pl-1">Personal (Not Approved)</div>
                              </div>
                              <div className="grid grid-cols-5 pb-0.5">
                                <div className="col-span-1 font-semibold text-right">OU -</div>
                                <div className="col-span-4 pl-1">Other Unpaid</div>
                              </div>
                              <div className="grid grid-cols-5 pb-0.5">
                                <div className="col-span-1 font-semibold text-right">PA -</div>
                                <div className="col-span-4 pl-1">Personal (Approved)</div>
                              </div>
                              <div className="grid grid-cols-5 pb-0.5">
                                <div className="col-span-1 font-semibold text-right">WC -</div>
                                <div className="col-span-4 pl-1">Personal (Approved)</div>
                              </div>
                              <div className="grid grid-cols-5 pb-0.5">
                                <div className="col-span-1 font-semibold text-right">D -</div>
                                <div className="col-span-4 pl-1">District Approved</div>
                              </div>
                              <div className="grid grid-cols-5 pb-0.5">
                                <div className="col-span-1 font-semibold text-right">I -</div>
                                <div className="col-span-4 pl-1">Illness</div>
                              </div>
                            </div>
                          </div>
                        </div> */}

                                                <div className='grid grid-cols-2 gap-4'>
                                                    <div className="bg-white border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                        <i className="mr-3 gusd-print-outline"></i><span>Print</span>
                                                    </div>

                                                    <div className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#fff] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                        <i className="mr-3 gusd-print-outline"></i><span>Download</span>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                        <div className="col-span-1 lg:col-span-4 bg-[#EFF0F1] h-auto">
                                            <div className="p-5">
                                                <div className="text-[#344054] text-[16px] font-medium py-3">Form History</div>
                                                <div>
                                                    <div className="text-[#000000] text-[12px] font-normal text-center py-2 separator">Yesterday</div>
                                                    <div className="flex items-start justify-between gap-2 py-2">
                                                        <Image src={user1} alt="user" width="32" height="32" />
                                                        <div className="">
                                                            <div className="flex justify-between">
                                                                <div>
                                                                    <div className="text-[#344054] font-semibold text-[14px]">Jhon Paul</div>
                                                                    <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                                                        <i className="mr-1 gusd-commented"></i>
                                                                        <span>Commented on parties Tab</span>
                                                                    </div>
                                                                </div>
                                                                <div className="text-[#344054] text-[12px]">09:00</div>
                                                            </div>
                                                            <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">changed the input name of employee from “Kalvin” to “Samston”.</div>
                                                        </div>
                                                    </div>
                                                    <div className="flex items-start justify-between gap-2 py-2">
                                                        <Image src={user2} alt="user" width="32" height="32" />
                                                        <div className="">
                                                            <div className="flex justify-between">
                                                                <div>
                                                                    <div className="text-[#344054] font-semibold text-[14px]">Jhoana Maria</div>
                                                                    <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                                                        <i className="mr-1 gusd-commented"></i>
                                                                        <span>Commented on parties Tab</span>
                                                                    </div>
                                                                </div>
                                                                <div className="text-[#344054] text-[12px]">09:00</div>
                                                            </div>
                                                            <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">changed the input name of employee from “Kalvin” to “Samston”.</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="text-[#000000] text-[12px] font-normal text-center py-2 separator">April 7h</div>
                                                    <div className="flex items-start justify-between gap-2 py-2">
                                                        <Image src="/assets/images/user3.svg" alt="user" width="32" height="32" />
                                                        <div className="">
                                                            <div className="flex justify-between">
                                                                <div>
                                                                    <div className="text-[#344054] font-semibold text-[14px]">Jennifer Lopez</div>
                                                                    <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                                                        <i className="mr-1 gusd-commented"></i>
                                                                        <span>Commented on parties Tab</span>
                                                                    </div>
                                                                </div>
                                                                <div className="text-[#344054] text-[12px]">09:00</div>
                                                            </div>
                                                            <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">changed the input name of employee from “Kalvin” to “Samston”.</div>
                                                        </div>
                                                    </div>
                                                    <div className="flex items-start justify-between gap-2 py-2">
                                                        <Image src="/assets/images/user4.svg" alt="user" width="32" height="32" />
                                                        <div className="">
                                                            <div className="flex justify-between">
                                                                <div>
                                                                    <div className="text-[#344054] font-semibold text-[14px]">Lethicia Jhansen</div>
                                                                    <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                                                        <i className="mr-1 gusd-commented"></i>
                                                                        <span>Commented on parties Tab</span>
                                                                    </div>
                                                                </div>
                                                                <div className="text-[#344054] text-[12px]">09:00</div>
                                                            </div>
                                                            <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">changed the input name of employee from “Kalvin” to “Samston”.</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="text-[#000000] text-[12px] font-normal text-center py-2 separator">April 7h</div>
                                                    <div className="flex items-start justify-between gap-2 py-2">
                                                        <Image src="/assets/images/user5.svg" alt="user" width="32" height="32" />
                                                        <div className="">
                                                            <div className="flex justify-between">
                                                                <div>
                                                                    <div className="text-[#344054] font-semibold text-[14px]">Jhon Doe</div>
                                                                    <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                                                        <i className="mr-1 gusd-commented"></i>
                                                                        <span>Commented on parties Tab</span>
                                                                    </div>
                                                                </div>
                                                                <div className="text-[#344054] text-[12px]">09:00</div>
                                                            </div>
                                                            <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">changed the input name of employee from “Kalvin” to “Samston”.</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Dialog>

                            </div>

                            {/* edit popup start */}
                            < Dialog className="relative reports-popup" visible={visibleEdit} position="right" style={{ width: `${(fullViewEdit) ? '50vw' : '30vw'}` }
                            } breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisibleEdit(false)} draggable={false} resizable={false} >
                                <div className="">
                                    <div className="bg-[#F5F6F7] relative h-screen">
                                        <div className="p-5">
                                            <a to='' onClick={() => setVisibleEdit(false)} className="py-3"><Image
                                                src={sidebar} alt="user" width="24" height="24" /></a>

                                            {
                                                (!fullViewEdit) ?
                                                    <div>
                                                        <div className="text-[#113699] text-md md:text-[0.833vw] font-bold">6th Period Teaching Assignment</div>
                                                        <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Sixth Period Teaching Assignment - Classified form</div>
                                                        <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                                                            <div className="mb-1">
                                                                <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">Approval Status</label>
                                                                <div className="py-3 emp-simple-tbl">
                                                                    <DataTable
                                                                        value={[
                                                                            {
                                                                                id: '1000',
                                                                                title: 'Principal',
                                                                                name: 'Alrick Barwa',
                                                                                status: 'Approved'
                                                                            },
                                                                            {
                                                                                id: '1001',
                                                                                title: 'Teacher',
                                                                                name: 'John Mishra',
                                                                                status: 'Approved'
                                                                            },
                                                                            {
                                                                                id: '1002',
                                                                                title: 'EAFE Program Administrator',
                                                                                name: 'Alrick Barwa',
                                                                                status: 'Approved'
                                                                            }

                                                                        ]}>
                                                                        <Column field="title" header="Title"></Column>
                                                                        <Column field="name" header="Name"></Column>
                                                                        <Column field="status" header="Status"></Column>
                                                                    </DataTable>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> : null
                                            }



                                            <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">

                                                {
                                                    (!fullViewEdit) ?
                                                        <div className='flex justify-between'>
                                                            <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-document"></i>Sixth Period.pdf</div>
                                                            <button onClick={() => setFullViewEdit(true)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>View Full Screen</button>
                                                        </div> :
                                                        <div className='flex justify-between'>
                                                            <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-document"></i>Sixth Period Teaching Assignment.pdf</div>
                                                            <button onClick={() => setFullViewEdit(false)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>Exit Full Screen</button>
                                                        </div>
                                                }


                                                {
                                                    (!fullViewEdit) ?
                                                        <div className="grid grid-cols-1">
                                                            <img src={pdfImageForEdit} alt='myImg' />
                                                        </div> :
                                                        <div className='mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw] overflow-y-auto' style={{ height: '580px' }}>
                                                            <img src={pdfImageReport} alt='pdfImageReport' />
                                                        </div>
                                                }



                                            </div>
                                        </div>


                                        {/* <div className="dialogpoput card flex justify-content-center">
                        <InputSwitch checked={checkedSignature} onChange={(e) => setCheckedSignature(e.value)} /><span className="text-[#1E3E5A] text-[14px] font-medium leading-5 tracking-[-0.02em] pl-2 ">Add e Signature</span>
                      </div> */}
                                        <div className="absolute  bottom-2 left-2 right-2 grid grid-cols-2 gap-2 ">

                                            <Link to='' className="bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center text-[#D92D20]"
                                                //  onClick={() => saveGroupInfo()}
                                                onClick={() => setRejectVisible(true)}
                                            ><i className="gusd-close mr-1" style={{ fontSize: '1rem' }}></i>Reject</Link>

                                            <button disabled className=" text-center flex items-center tableBtn border border-[#D0D5DD] text-[#039855] radius8"
                                            ><i className="pi pi-check mr-1" style={{ fontSize: '1rem' }}></i>process</button>

                                        </div>
                                    </div>
                                </div>
                            </Dialog>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    ) : (
        <Login sessionExpired={1} />
    );
}

export default ServiceAgreementPayrollReportList